import { Component, OnInit, } from '@angular/core';

@Component({
    selector: 'public',
    templateUrl: './public.component.html'
})
export class PublicComponent implements OnInit {
    ngOnInit(): void {

    }
}
